import React from 'react'
import { GlobalBox } from 'components/Box/GlobalBox'
import PersonIcon from '@mui/icons-material/Person';
import { useSelector } from 'react-redux';
import { UserForm } from './UserForm';

export const UserDetails = () => {
  const {user, isEdit} = useSelector(({users}) => users )
  return (
    <GlobalBox
      icon={<PersonIcon />}
      title="Editar Usuario"
    >
      <UserForm data={user} isEdit={isEdit}/>
    </GlobalBox>
  )
}
